import { differenceInMinutes } from 'date-fns';
import { z } from 'zod';
import { combineDateTime } from './util';
export const routeSheetValidationSchema = z.object({
    id: z.string(),
    data: z
        .object({
        timeIn: z.string().nullish(),
        timeOut: z.string().nullish(),
        status: z.string({ message: 'Visit status is required' }),
        patientAcknowledgment: z.boolean().nullish(),
        mileage: z.string().nullish(),
        surcharge: z.string().nullish(),
        additional: z.string().nullish(),
        visitType: z.string().nullish(),
        visitDate: z.string().nullish(),
        assignedUser: z.string().nullish(),
        reasonForMissing: z.string().nullish(),
    })
        .superRefine((data, ctx) => {
        if (data.status === 'completed') {
            const fields = ['timeIn', 'timeOut'];
            if (data.timeIn && data.timeOut && data.visitDate) {
                const timeIn = combineDateTime(data.visitDate, data.timeIn);
                const timeOut = combineDateTime(data.visitDate, data.timeOut);
                const diff = differenceInMinutes(timeOut, timeIn);
                if (diff < 0) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        path: ['timeOut'],
                        message: 'Time out must be after time in',
                    });
                }
                else if (diff < 20) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        path: ['timeOut'],
                        message: 'Visit must be longer than 20 minutes',
                    });
                }
            }
            for (const field of fields) {
                if (!data[field]) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.custom,
                        path: [field],
                        message: 'required',
                    });
                }
            }
        }
        else if (data.status === 'missed') {
            if (!data.reasonForMissing) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: ['reasonForMissing'],
                    message: 'required',
                });
            }
        }
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
